import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { ConsoleLogger, HttpService, Query, TaggedUrl, Tags } from '@skylab-shared/core';
import { extractFilenameFromHeaders, fillPlaceholders } from '@skylab-shared/utils';

export interface EInvoiceReceivedGetHeaderXmlQueryParams {
    documentHeaderId: number;
}

export interface EInvoiceReceivedGetHeaderXmlQueryResult {
    readonly xml: string;
    readonly file: Blob;
    readonly filename: string;
}

export class EInvoiceReceivedGetHeaderXmlQuery extends Query<EInvoiceReceivedGetHeaderXmlQueryResult | undefined> {
    public constructor(public readonly params: EInvoiceReceivedGetHeaderXmlQueryParams) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(EInvoiceReceivedGetHeaderXmlQuery)
export class EInvoiceReceivedGetHeaderXmlQueryHandler {
    #Url = TaggedUrl.join('eInvoices/headers/:id/xml', [Tags.Api]);
    #logger = new ConsoleLogger(this.constructor.name);
    #http = inject(Http) as HttpService;

    public async handleAsync({ params }: EInvoiceReceivedGetHeaderXmlQuery): Promise<EInvoiceReceivedGetHeaderXmlQueryResult | undefined> {
        try {
            const url = fillPlaceholders(this.#Url, { id: params.documentHeaderId });
            const response = await this.#http.get<Blob>(url, {
                responseType: 'blob'
            });

            if (response.status !== 200 || !response.data.size) return undefined;

            return {
                xml: await response.data.text(),
                file: response.data,
                filename: extractFilenameFromHeaders(response) ?? ''
            };
        } catch (err) {
            this.#logger.error(err);
        }

        return undefined;
    }
}
